import { getApiResponseErrorMessage } from './api'
import { getErrorObject } from './errors'

export async function handleAsync<T>(
	promise: Promise<T>,
	default_error_message = 'An error occurred',
	params: { expect_fl_api_error?: boolean } = {},
): Promise<[T, null] | [null, Error]> {
	const { expect_fl_api_error = true } = params

	try {
		const data = await promise

		return [data, null]
	} catch (err: unknown) {
		return [
			null,
			getErrorObject(
				expect_fl_api_error ? getApiResponseErrorMessage(err, default_error_message) : err,
				default_error_message,
			),
		]
	}
}

/**
 * Test if a value is a pending promise
 *
 * @param value The value to examine as a potential pending promise
 * @returns boolean True if the value is a pending promise
 */
export function isPromiseLike(value: unknown) {
	return (
		// Check if the string representation of the prototype is "[object Promise]"
		Object.prototype.toString.call(value) === '[object Promise]' ||
		// Check if the value is an object and has a "then" property which is a function
		(typeof value === 'object' && value !== null && 'then' in value && typeof value.then === 'function')
	)
}
